export const uniqBy = <T extends any>(values: T[], key: keyof T): T[] => {
    const seen = new Set()

    return values.filter((item) => {
        const val = item[key]
        if (seen.has(val)) {
            return false
        }
        seen.add(val)
        return true
    })
}
